import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AdGroupRoleMappingAdminApi } from './api/adGroupRoleMappingAdmin.api';
import { ClientAdminApi } from './api/clientAdmin.api';
import { ConsentApi } from './api/consent.api';
import { LoginApi } from './api/login.api';
import { ProfileApi } from './api/profile.api';
import { RolesApi } from './api/roles.api';
import { SignupApi } from './api/signup.api';
import { UserAdminApi } from './api/userAdmin.api';
import { UsersApi } from './api/users.api';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
